import {
  playerAnalyticsBaseUrl,
  getShortTokenID,
  getDeviceID,
  getSessionID,
} from './mys4c_helpers';

/*
 * Fire and forget - a failed event must never surface to the user or delay
 * navigation into the programme, so there is no retry and no error handling
 * beyond swallowing the rejection.
 */
function postAnalyticsEvent(path, payload) {
  const url = `${playerAnalyticsBaseUrl()}/${path}`;
  const body = JSON.stringify(payload);

  try {
    if (typeof window.fetch === 'function') {
      window
        .fetch(url, {
          method: 'POST',
          keepalive: true,
          headers: { 'Content-Type': 'application/json' },
          body,
        })
        .catch(() => {});
    } else if (navigator.sendBeacon) {
      navigator.sendBeacon(url, new Blob([body], { type: 'application/json' }));
    }
  } catch (e) {
    // silent
  }
}

/*
 * Signed in: the first two parts of the auth token.
 * Anonymous: the persistent device id, which personalize already receives as
 * advertising_id on every recommendations request, so anonymous clicks join back
 * to the request that produced the rid.
 */
function getTkn() {
  const shortToken = getShortTokenID();
  return shortToken ? shortToken : `anon-${getDeviceID()}`;
}

export function sendCardClickEvent(details) {
  // Recommendation cards link to series level, so the pid can only come from
  // the card's own data - never from the url or the route params.
  //
  // This also excludes cards rendered without details: live tiles, online
  // exclusives, and the CMS promo tiles in the "Ein pigion" row. The promo tiles
  // do link to programmes, but only via an arbitrary CMS url with no pid
  // alongside it, so they are knowingly left out rather than parsed out of the
  // url. Giving them a pid is a CMS-side change.
  if (!details || !details.id) {
    return;
  }

  const payload = {
    playerData: {
      eventType: 'click',
      tkn: getTkn(),
      pid: `${details.id}`,
      ts: Math.floor(Date.now() / 1000),
    },
    sessionData: {
      sessionId: getSessionID(),
    },
  };

  if (details.recommendationId) {
    payload.recommendations = { rid: details.recommendationId };
  }

  postAnalyticsEvent('click', payload);
}
